export default __webpack_public_path__ + "static/soon-7718629e34e55bbf0ca326445ecd645a.svg";